import { FieldType } from "../../../../../../../../procurement/components/create_view/form_field";

export const requiredFields = [
  "Vehicle Type",
  "Category (2W/3W/4W/Others)",
  "Brand",
  "Model",
  "Battery Capacity (kWh)",
  "Connector Type (1)",
  "Connector Type (2)",
  "Max_Charging_Power_AC_kW",
  "Max_Charging_Power_DC_kW",
  "Range (KMs/charge)",
  "Link",
];

export const requiredFieldsKeyname: { [header: string]: string } = {
  "Vehicle Type": "type",
  "Category (2W/3W/4W/Others)": "category",
  Brand: "brand",
  Model: "model",
  "Battery Capacity (kWh)": "battery_capacity",
  "Connector Type (1)": "connector_type",
  "Connector Type (2)": "connector_type2",
  "Range (KMs/charge)": "range",
  Link: "link",
};

export const EVTableHeaderList = [
  {
    key: requiredFieldsKeyname["Vehicle Type"],
    value: "Vehicle Type",
    type: FieldType.string,
  },
  // {
  //   key: requiredFieldsKeyname["Category (2W/3W/4W/Others)"],
  //   value: "Category (2W/3W/4W/Others)",
  //   type: FieldType.string,
  // },
  {
    key: requiredFieldsKeyname["Brand"],
    value: "Brand",
    type: FieldType.string,
  },
  {
    key: requiredFieldsKeyname["Model"],
    value: "Model",
    type: FieldType.string,
  },
  {
    key: requiredFieldsKeyname["Battery Capacity (kWh)"],
    value: "Battery Capacity (kWh)",
    type: FieldType.string,
  },
  {
    key: requiredFieldsKeyname["Charging Standard"],
    value: "Charging Standard",
    type: FieldType.string,
  },
  {
    key: requiredFieldsKeyname["Connector Type"],
    value: "Connector Type",
    type: FieldType.string,
  },
  {
    key: requiredFieldsKeyname["Range (KMs/charge)"],
    value: "Range (KMs/charge)",
    type: FieldType.string,
  },

  // {
  //   key: requiredFieldsKeyname["Link"],
  //   value: "Link",
  //   type: FieldType.string,
  // },
];
